import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Button, Icon, Text } from "@ui-component-library";

const HeroBanner = (props) => {

  const handleButtonClick = (href) => {
    window.location.href = href;
  };
  return (
    <TailwindWrapper>
       <section className="w-full py-18 bg-pebble-1200">
       <div className="container flex flex-col items-center gap-6 text-center">
          {/* Hero section name */}
          <Text
            tw
            variant="overlineLargeRegular"
            className="text-white-700"
          >
            {props.sectionName}
          </Text>
          {/* Main Headline */}
          <Text
            tw
            variant="text-3xl/leading-normal/medium"
            className="text-white-200"
          >
            {props.title}
          </Text>
          {/* Description Text */}
          <Text
            tw
            variant="text-base/leading-normal/normal"
            className="text-white-700 mb-4"
          >
            {props.text}
          </Text>
          <Button tw variant="secondary">
            {props.buttonText}
            <Icon tw name="ArrowRightSimple" size="medium" />
          </Button>
        </div>
      </section>
    </TailwindWrapper>
  );
};

HeroBanner.defaultProps = {
  sectionName: "CTA section",
  title: "Action-driving headline that creates urgency",
  text: "Add one or two compelling sentences that reinforce your main value proposition and overcome final objections. End with a clear reason to act now. Align this copy with your CTA button text.",
  buttonText: "Get started",
  buttonLink: "/",
};

HeroBanner.fields = {
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
  buttonText: {
    type: "text",
    label: "Button text",
  },
  buttonLink: {
    type: "text",
    label: "Button link",
  },
};

export default HeroBanner;
